module.exports = __webpack_public_path__ + "static/media/audio-default.0dead4ec.mp3";